module.exports = function (e) {
  var n = {};

  function t(o) {
    if (n[o]) return n[o].exports;
    var r = n[o] = {
      i: o,
      l: !1,
      exports: {}
    };
    return e[o].call(r.exports, r, r.exports, t), r.l = !0, r.exports;
  }

  return t.m = e, t.c = n, t.d = function (e, n, o) {
    t.o(e, n) || Object.defineProperty(e, n, {
      enumerable: !0,
      get: o
    });
  }, t.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, t.t = function (e, n) {
    if (1 & n && (e = t(e)), 8 & n) return e;
    if (4 & n && "object" == typeof e && e && e.__esModule) return e;
    var o = Object.create(null);
    if (t.r(o), Object.defineProperty(o, "default", {
      enumerable: !0,
      value: e
    }), 2 & n && "string" != typeof e) for (var r in e) {
      t.d(o, r, function (n) {
        return e[n];
      }.bind(null, r));
    }
    return o;
  }, t.n = function (e) {
    var n = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return t.d(n, "a", n), n;
  }, t.o = function (e, n) {
    return Object.prototype.hasOwnProperty.call(e, n);
  }, t.p = "", t(t.s = 8);
}([function (e, n) {
  e.exports = require("react");
}, function (e, n, t) {
  "use strict";

  e.exports = function (e) {
    var n = [];
    return n.toString = function () {
      return this.map(function (n) {
        var t = function (e, n) {
          var t = e[1] || "",
              o = e[3];
          if (!o) return t;

          if (n && "function" == typeof btoa) {
            var r = (i = o, s = btoa(unescape(encodeURIComponent(JSON.stringify(i)))), c = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(s), "/*# ".concat(c, " */")),
                a = o.sources.map(function (e) {
              return "/*# sourceURL=".concat(o.sourceRoot).concat(e, " */");
            });
            return [t].concat(a).concat([r]).join("\n");
          }

          var i, s, c;
          return [t].join("\n");
        }(n, e);

        return n[2] ? "@media ".concat(n[2], "{").concat(t, "}") : t;
      }).join("");
    }, n.i = function (e, t) {
      "string" == typeof e && (e = [[null, e, ""]]);

      for (var o = {}, r = 0; r < this.length; r++) {
        var a = this[r][0];
        null != a && (o[a] = !0);
      }

      for (var i = 0; i < e.length; i++) {
        var s = e[i];
        null != s[0] && o[s[0]] || (t && !s[2] ? s[2] = t : t && (s[2] = "(".concat(s[2], ") and (").concat(t, ")")), n.push(s));
      }
    }, n;
  };
}, function (e, n, t) {
  var o,
      r,
      a = {},
      i = (o = function o() {
    return window && document && document.all && !window.atob;
  }, function () {
    return void 0 === r && (r = o.apply(this, arguments)), r;
  }),
      s = function (e) {
    var n = {};
    return function (e, t) {
      if ("function" == typeof e) return e();

      if (void 0 === n[e]) {
        var o = function (e, n) {
          return n ? n.querySelector(e) : document.querySelector(e);
        }.call(this, e, t);

        if (window.HTMLIFrameElement && o instanceof window.HTMLIFrameElement) try {
          o = o.contentDocument.head;
        } catch (e) {
          o = null;
        }
        n[e] = o;
      }

      return n[e];
    };
  }(),
      c = null,
      u = 0,
      m = [],
      f = t(5);

  function l(e, n) {
    for (var t = 0; t < e.length; t++) {
      var o = e[t],
          r = a[o.id];

      if (r) {
        r.refs++;

        for (var i = 0; i < r.parts.length; i++) {
          r.parts[i](o.parts[i]);
        }

        for (; i < o.parts.length; i++) {
          r.parts.push(g(o.parts[i], n));
        }
      } else {
        var s = [];

        for (i = 0; i < o.parts.length; i++) {
          s.push(g(o.parts[i], n));
        }

        a[o.id] = {
          id: o.id,
          refs: 1,
          parts: s
        };
      }
    }
  }

  function p(e, n) {
    for (var t = [], o = {}, r = 0; r < e.length; r++) {
      var a = e[r],
          i = n.base ? a[0] + n.base : a[0],
          s = {
        css: a[1],
        media: a[2],
        sourceMap: a[3]
      };
      o[i] ? o[i].parts.push(s) : t.push(o[i] = {
        id: i,
        parts: [s]
      });
    }

    return t;
  }

  function d(e, n) {
    var t = s(e.insertInto);
    if (!t) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
    var o = m[m.length - 1];
    if ("top" === e.insertAt) o ? o.nextSibling ? t.insertBefore(n, o.nextSibling) : t.appendChild(n) : t.insertBefore(n, t.firstChild), m.push(n);else if ("bottom" === e.insertAt) t.appendChild(n);else {
      if ("object" != typeof e.insertAt || !e.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
      var r = s(e.insertAt.before, t);
      t.insertBefore(n, r);
    }
  }

  function h(e) {
    if (null === e.parentNode) return !1;
    e.parentNode.removeChild(e);
    var n = m.indexOf(e);
    n >= 0 && m.splice(n, 1);
  }

  function b(e) {
    var n = document.createElement("style");

    if (void 0 === e.attrs.type && (e.attrs.type = "text/css"), void 0 === e.attrs.nonce) {
      var o = function () {
        0;
        return t.nc;
      }();

      o && (e.attrs.nonce = o);
    }

    return v(n, e.attrs), d(e, n), n;
  }

  function v(e, n) {
    Object.keys(n).forEach(function (t) {
      e.setAttribute(t, n[t]);
    });
  }

  function g(e, n) {
    var t, o, r, a;

    if (n.transform && e.css) {
      if (!(a = "function" == typeof n.transform ? n.transform(e.css) : n.transform.default(e.css))) return function () {};
      e.css = a;
    }

    if (n.singleton) {
      var i = u++;
      t = c || (c = b(n)), o = x.bind(null, t, i, !1), r = x.bind(null, t, i, !0);
    } else e.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (t = function (e) {
      var n = document.createElement("link");
      return void 0 === e.attrs.type && (e.attrs.type = "text/css"), e.attrs.rel = "stylesheet", v(n, e.attrs), d(e, n), n;
    }(n), o = function (e, n, t) {
      var o = t.css,
          r = t.sourceMap,
          a = void 0 === n.convertToAbsoluteUrls && r;
      (n.convertToAbsoluteUrls || a) && (o = f(o));
      r && (o += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(r)))) + " */");
      var i = new Blob([o], {
        type: "text/css"
      }),
          s = e.href;
      e.href = URL.createObjectURL(i), s && URL.revokeObjectURL(s);
    }.bind(null, t, n), r = function r() {
      h(t), t.href && URL.revokeObjectURL(t.href);
    }) : (t = b(n), o = function (e, n) {
      var t = n.css,
          o = n.media;
      o && e.setAttribute("media", o);
      if (e.styleSheet) e.styleSheet.cssText = t;else {
        for (; e.firstChild;) {
          e.removeChild(e.firstChild);
        }

        e.appendChild(document.createTextNode(t));
      }
    }.bind(null, t), r = function r() {
      h(t);
    });

    return o(e), function (n) {
      if (n) {
        if (n.css === e.css && n.media === e.media && n.sourceMap === e.sourceMap) return;
        o(e = n);
      } else r();
    };
  }

  e.exports = function (e, n) {
    if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
    (n = n || {}).attrs = "object" == typeof n.attrs ? n.attrs : {}, n.singleton || "boolean" == typeof n.singleton || (n.singleton = i()), n.insertInto || (n.insertInto = "head"), n.insertAt || (n.insertAt = "bottom");
    var t = p(e, n);
    return l(t, n), function (e) {
      for (var o = [], r = 0; r < t.length; r++) {
        var i = t[r];
        (s = a[i.id]).refs--, o.push(s);
      }

      e && l(p(e, n), n);

      for (r = 0; r < o.length; r++) {
        var s;

        if (0 === (s = o[r]).refs) {
          for (var c = 0; c < s.parts.length; c++) {
            s.parts[c]();
          }

          delete a[s.id];
        }
      }
    };
  };

  var w,
      y = (w = [], function (e, n) {
    return w[e] = n, w.filter(Boolean).join("\n");
  });

  function x(e, n, t, o) {
    var r = t ? "" : o.css;
    if (e.styleSheet) e.styleSheet.cssText = y(n, r);else {
      var a = document.createTextNode(r),
          i = e.childNodes;
      i[n] && e.removeChild(i[n]), i.length ? e.insertBefore(a, i[n]) : e.appendChild(a);
    }
  }
}, function (e, n, t) {
  var o = t(4);
  "string" == typeof o && (o = [[e.i, o, ""]]);
  var r = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(2)(o, r);
  o.locals && (e.exports = o.locals);
}, function (e, n, t) {
  (e.exports = t(1)(!1)).push([e.i, 'body {\n  /*=== Used for push effect === */\n  -webkit-transition: padding 0.3s ease-out;\n  -moz-transition: padding 0.3s ease-out;\n  transition: padding 0.3s ease-out; }\n\n.eom-offcanvas {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: auto;\n  width: 320px;\n  height: 100%;\n  background: #282c34;\n  color: #eee;\n  -webkit-transform: translate(-100%, 0);\n  -moz-transform: translate(-100%, 0);\n  transform: translate(-100%, 0);\n  -webkit-transition: transform 0.3s ease-out;\n  -moz-transition: transform 0.3s ease-out;\n  transition: transform 0.3s ease-out;\n  z-index: 9999;\n  /* ==== Offcanvas Opened - active state ==== */\n  /* ==== Inner Container ==== */\n  /* ==== Hamburger Icon ==== */\n  /* ==== Main Menu ==== */\n  /* ==== Light Skin ==== */ }\n  .eom-offcanvas * {\n    box-sizing: border-box; }\n  .eom-offcanvas.active {\n    -webkit-transform: translate(0, 0);\n    -moz-transform: translate(0, 0);\n    transform: translate(0, 0); }\n    .eom-offcanvas.active .eom-hamburger-wrap span {\n      position: absolute;\n      transform-origin: 0 0; }\n      .eom-offcanvas.active .eom-hamburger-wrap span:first-child {\n        top: calc(50% - 3px);\n        left: 50%;\n        -webkit-transform: rotate(45deg) translate(-50%);\n        -moz-transform: rotate(45deg) translate(-50%);\n        transform: rotate(45deg) translate(-50%); }\n      .eom-offcanvas.active .eom-hamburger-wrap span:nth-child(2) {\n        opacity: 0; }\n      .eom-offcanvas.active .eom-hamburger-wrap span:last-child {\n        top: calc(50% - 3px);\n        left: calc(50% - 2px);\n        -webkit-transform: rotate(-45deg) translate(-50%);\n        -moz-transform: rotate(-45deg) translate(-50%);\n        transform: rotate(-45deg) translate(-50%); }\n  .eom-offcanvas .menu-overflow {\n    display: flex;\n    justify-content: left;\n    align-items: flex-start;\n    flex-direction: column;\n    height: 100vh;\n    padding: 2em 1.5em 1em;\n    overflow-y: auto; }\n    .eom-offcanvas .menu-overflow ul {\n      padding: 0;\n      margin: 0;\n      list-style: none;\n      text-align: left; }\n  .eom-offcanvas .eom-header,\n  .eom-offcanvas .eom-footer {\n    width: 100%; }\n  .eom-offcanvas .eom-hamburger-wrap {\n    position: absolute;\n    top: 10px;\n    left: auto;\n    right: -10px;\n    width: auto;\n    height: auto;\n    width: 42px;\n    height: 35px;\n    padding: 3px;\n    border: 3px solid #333;\n    border-radius: 3px;\n    -webkit-transform: translate(100%, 0);\n    -moz-transform: translate(100%, 0);\n    transform: translate(100%, 0);\n    -webkit-transition: border-color 0.3s;\n    -moz-transition: border-color 0.3s;\n    transition: border-color 0.3s; }\n    .eom-offcanvas .eom-hamburger-wrap:hover {\n      border-color: #20d620; }\n      .eom-offcanvas .eom-hamburger-wrap:hover span {\n        border-color: #20d620; }\n    .eom-offcanvas .eom-hamburger-wrap .eom-hamburger {\n      position: relative;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      flex-direction: column;\n      width: 100;\n      height: 100%; }\n    .eom-offcanvas .eom-hamburger-wrap span {\n      display: block;\n      width: calc(100% - 3px);\n      border-top: 3px solid #333;\n      flex: 1;\n      margin: 2px 0;\n      -webkit-transition: transform 0.5s, opacity 0.3s, border-color 0.3s;\n      -moz-transition: transform 0.5s, opacity 0.3s, border-color 0.3s;\n      transition: transform 0.5s, opacity 0.3s, border-color 0.3s; }\n  .eom-offcanvas .eom-menu-wrap {\n    position: relative;\n    flex: 2;\n    width: 100%;\n    text-align: left;\n    /* ==== Submenu ==== */ }\n    .eom-offcanvas .eom-menu-wrap .eom-menu {\n      padding: 0;\n      margin: 0;\n      list-style: none; }\n      .eom-offcanvas .eom-menu-wrap .eom-menu:not(.eom-submenu) {\n        padding-top: 3em; }\n    .eom-offcanvas .eom-menu-wrap .eom-menu-item-wrap {\n      position: relative; }\n    .eom-offcanvas .eom-menu-wrap .eom-menu-item {\n      position: relative;\n      display: flex;\n      justify-content: left;\n      align-items: center;\n      flex-direction: row;\n      padding: 10px 0;\n      color: #eee;\n      font-size: 1.3em;\n      text-decoration: none;\n      -webkit-transition: color 0.3s;\n      -moz-transition: color 0.3s;\n      transition: color 0.3s; }\n      .eom-offcanvas .eom-menu-wrap .eom-menu-item:after {\n        position: absolute;\n        top: auto;\n        left: 0;\n        right: auto;\n        width: auto;\n        height: auto;\n        bottom: 2px;\n        display: block;\n        width: 100%;\n        max-width: 0;\n        content: " ";\n        border-bottom: 3px solid #20d620;\n        opacity: 0;\n        -webkit-transition: opacity 0.3s, max-width 0.3s;\n        -moz-transition: opacity 0.3s, max-width 0.3s;\n        transition: opacity 0.3s, max-width 0.3s; }\n      .eom-offcanvas .eom-menu-wrap .eom-menu-item.active, .eom-offcanvas .eom-menu-wrap .eom-menu-item:hover {\n        color: #fff; }\n        .eom-offcanvas .eom-menu-wrap .eom-menu-item.active:after, .eom-offcanvas .eom-menu-wrap .eom-menu-item:hover:after {\n          max-width: 10%;\n          opacity: 1; }\n      .eom-offcanvas .eom-menu-wrap .eom-menu-item > span {\n        position: relative;\n        display: inline-block; }\n      .eom-offcanvas .eom-menu-wrap .eom-menu-item .menu-text {\n        width: calc(100% - 22px); }\n      .eom-offcanvas .eom-menu-wrap .eom-menu-item .sub-arrow {\n        width: 22px;\n        height: 20px;\n        border: 1px solid currentColor; }\n        .eom-offcanvas .eom-menu-wrap .eom-menu-item .sub-arrow.active i:first-child {\n          left: calc(50% - 3px);\n          -webkit-transform: rotate(30deg) translateY(-50%);\n          -moz-transform: rotate(30deg) translateY(-50%);\n          transform: rotate(30deg) translateY(-50%); }\n        .eom-offcanvas .eom-menu-wrap .eom-menu-item .sub-arrow.active i:last-child {\n          left: calc(50% + 3px);\n          -webkit-transform: rotate(-30deg) translateY(-50%);\n          -moz-transform: rotate(-30deg) translateY(-50%);\n          transform: rotate(-30deg) translateY(-50%); }\n        .eom-offcanvas .eom-menu-wrap .eom-menu-item .sub-arrow i {\n          position: absolute;\n          top: calc(50% - 1px);\n          left: 50%;\n          right: auto;\n          width: auto;\n          height: auto;\n          display: block;\n          content: " ";\n          height: 7px;\n          border-right: 1px solid currentColor;\n          -webkit-transition: transform 0.4s;\n          -moz-transition: transform 0.4s;\n          transition: transform 0.4s; }\n          .eom-offcanvas .eom-menu-wrap .eom-menu-item .sub-arrow i:first-child {\n            left: 50%;\n            -webkit-transform: rotate(-30deg) translateY(-50%);\n            -moz-transform: rotate(-30deg) translateY(-50%);\n            transform: rotate(-30deg) translateY(-50%); }\n          .eom-offcanvas .eom-menu-wrap .eom-menu-item .sub-arrow i:last-child {\n            left: 50%;\n            -webkit-transform: rotate(30deg) translateY(-50%);\n            -moz-transform: rotate(30deg) translateY(-50%);\n            transform: rotate(30deg) translateY(-50%); }\n    .eom-offcanvas .eom-menu-wrap .eom-submenu {\n      max-height: 0;\n      padding: 0 0 0 15px;\n      background: #444;\n      overflow: hidden;\n      -webkit-transition: max-height 0.3s ease-in;\n      -moz-transition: max-height 0.3s ease-in;\n      transition: max-height 0.3s ease-in; }\n      .eom-offcanvas .eom-menu-wrap .eom-submenu.active {\n        max-height: 550px; }\n      .eom-offcanvas .eom-menu-wrap .eom-submenu .eom-menu-item {\n        font-size: 1.1em; }\n  .eom-offcanvas.eom-light {\n    background: #fff;\n    color: #444; }\n    .eom-offcanvas.eom-light .eom-hamburger-wrap {\n      border: 3px solid #fff; }\n      .eom-offcanvas.eom-light .eom-hamburger-wrap span {\n        border-top: 3px solid #fff; }\n      .eom-offcanvas.eom-light .eom-hamburger-wrap:hover {\n        border-color: #eee; }\n        .eom-offcanvas.eom-light .eom-hamburger-wrap:hover span {\n          border-color: #eee; }\n    .eom-offcanvas.eom-light .eom-menu-item {\n      color: #444; }\n      .eom-offcanvas.eom-light .eom-menu-item.active, .eom-offcanvas.eom-light .eom-menu-item:hover {\n        color: #000; }\n    .eom-offcanvas.eom-light .eom-submenu {\n      background: #eee; }\n', ""]);
}, function (e, n) {
  e.exports = function (e) {
    var n = "undefined" != typeof window && window.location;
    if (!n) throw new Error("fixUrls requires window.location");
    if (!e || "string" != typeof e) return e;
    var t = n.protocol + "//" + n.host,
        o = t + n.pathname.replace(/\/[^\/]*$/, "/");
    return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (e, n) {
      var r,
          a = n.trim().replace(/^"(.*)"$/, function (e, n) {
        return n;
      }).replace(/^'(.*)'$/, function (e, n) {
        return n;
      });
      return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(a) ? e : (r = 0 === a.indexOf("//") ? a : 0 === a.indexOf("/") ? t + a : o + a.replace(/^\.\//, ""), "url(" + JSON.stringify(r) + ")");
    });
  };
}, function (e, n, t) {
  var o = t(7);
  "string" == typeof o && (o = [[e.i, o, ""]]);
  var r = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  t(2)(o, r);
  o.locals && (e.exports = o.locals);
}, function (e, n, t) {
  (e.exports = t(1)(!1)).push([e.i, "@media only screen and (max-width: 460px) {\n  body {\n    padding-left: 0 !important; }\n  .eom-offcanvas {\n    max-width: 270px; }\n    .eom-offcanvas .eom-menu-wrap .eom-menu-item .sub-arrow {\n      width: 50px;\n      height: 32px; } }\n", ""]);
}, function (e, n, t) {
  "use strict";

  t.r(n);

  var o = t(0),
      r = t.n(o),
      a = r.a.createContext(),
      i = function i(e) {
    var n = e.item,
        t = e.context,
        o = e.hasSubmenu,
        a = t.Link,
        i = ["eom-menu-item"];
    return t.currentPage === n.link && i.push("active"), r.a.createElement(a, {
      id: "menu-".concat(n.text.toLowerCase()),
      className: i.join(" "),
      to: n.link
    }, r.a.createElement("span", {
      className: "menu-text"
    }, n.text), n.submenu ? r.a.createElement("span", {
      className: "".concat(o ? "sub-arrow active" : "sub-arrow"),
      onClick: function onClick(e) {
        return t.handleSubmenu(e, n.text.toLowerCase());
      }
    }, r.a.createElement("i", null), r.a.createElement("i", null)) : "");
  },
      s = function s(e) {
    var n = e.item,
        t = e.context,
        o = e.hasSubmenu,
        a = ["eom-menu-item"];
    return t.currentPage === n.link && a.push("active"), r.a.createElement("a", {
      href: "#",
      id: "menu-".concat(n.text.toLowerCase()),
      className: a.join(" "),
      onClick: function onClick(e) {
        e.preventDefault(), window.location.replace(n.link);
      }
    }, r.a.createElement("span", {
      className: "menu-text"
    }, n.text), n.submenu ? r.a.createElement("span", {
      className: "".concat(o ? "sub-arrow active" : "sub-arrow"),
      onClick: function onClick(e) {
        return t.handleSubmenu(e, n.text.toLowerCase());
      }
    }, r.a.createElement("i", null), r.a.createElement("i", null)) : "");
  },
      c = function c(e) {
    var n = e.item;
    return r.a.createElement(a.Consumer, null, function (e) {
      var t = e.openedSubmenus,
          o = e.Link,
          a = t.includes(n.text.toLowerCase());
      return r.a.createElement("li", {
        className: "eom-menu-item-wrap"
      }, o ? r.a.createElement(i, {
        item: n,
        context: e,
        hasSubmenu: a
      }) : r.a.createElement(s, {
        item: n,
        context: e,
        hasSubmenu: a
      }), n.submenu ? r.a.createElement(u, {
        items: n.submenu,
        classes: "".concat(a ? "eom-submenu active" : "eom-submenu")
      }) : "");
    });
  },
      u = function u(e) {
    var n = e.items,
        t = e.classes,
        o = ["eom-menu"];
    return t && o.push(t), r.a.createElement("ul", {
      className: o.join(" ")
    }, n.map(function (e) {
      return r.a.createElement(c, {
        key: e.text,
        item: e
      });
    }));
  },
      m = function m(e) {
    var n = e.menuCloseOpen;
    return r.a.createElement("div", {
      className: "eom-hamburger-wrap"
    }, r.a.createElement("a", {
      className: "eom-hamburger",
      href: "#",
      title: "Menu",
      onClick: function onClick(e) {
        return n(e);
      }
    }, r.a.createElement("span", null), r.a.createElement("span", null), r.a.createElement("span", null)));
  },
      f = function f(e) {
    var n = e.config,
        t = e.menu,
        o = e.header,
        a = e.footer,
        i = e.menuCloseOpen,
        s = e.isOpen,
        c = ["eom-offcanvas"],
        f = (n && n.width ? n.width : 320).width;
    return s && c.push("active"), n && "light" === n.skin && c.push("eom-light"), r.a.createElement("div", {
      className: c.join(" "),
      style: {
        width: f
      }
    }, r.a.createElement(m, {
      menuCloseOpen: i
    }), r.a.createElement("div", {
      className: "menu-overflow"
    }, o ? r.a.createElement("div", {
      className: "eom-header"
    }, o) : "", r.a.createElement("div", {
      className: "eom-menu-wrap"
    }, r.a.createElement(u, {
      items: t
    })), a ? r.a.createElement("div", {
      className: "eom-footer"
    }, a) : ""));
  };

  t(3), t(6);

  function l(e) {
    return (l = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function p(e, n) {
    var t = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      n && (o = o.filter(function (n) {
        return Object.getOwnPropertyDescriptor(e, n).enumerable;
      })), t.push.apply(t, o);
    }

    return t;
  }

  function d(e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = null != arguments[n] ? arguments[n] : {};
      n % 2 ? p(t, !0).forEach(function (n) {
        w(e, n, t[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : p(t).forEach(function (n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
      });
    }

    return e;
  }

  function h(e, n) {
    for (var t = 0; t < n.length; t++) {
      var o = n[t];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
    }
  }

  function b(e) {
    return (b = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function v(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function g(e, n) {
    return (g = Object.setPrototypeOf || function (e, n) {
      return e.__proto__ = n, e;
    })(e, n);
  }

  function w(e, n, t) {
    return n in e ? Object.defineProperty(e, n, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[n] = t, e;
  }

  t.d(n, "default", function () {
    return y;
  });

  var y = function (e) {
    function n(e) {
      var t, o, r;
      return function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, n), o = this, r = b(n).call(this, e), t = !r || "object" !== l(r) && "function" != typeof r ? v(o) : r, w(v(t), "menuCloseOpen", function (e) {
        e.preventDefault();
        var n = t.props.config,
            o = t.state.menuOpen;
        n.push && (o ? (document.body.classList.remove("eom-push"), document.body.style.paddingLeft = 0) : (document.body.classList.add("eom-push"), document.body.style.paddingLeft = n && n.width ? n.width : "320px")), t.setState({
          menuOpen: !o
        });
      }), w(v(t), "handleSubmenu", function (e, n) {
        e.preventDefault();
        var o = t.state.openedSubmenus;

        if (-1 !== o.indexOf(n)) {
          var r = o.indexOf(n);
          delete o[r];
        } else o.push(n);

        t.setState({
          openedSubmenus: o
        });
      }), t.state = {
        menuOpen: !!t.props.isOpen,
        openedSubmenus: [],
        currentPage: t.props.location ? t.props.location.pathname : window.location.pathname
      }, t.menuCloseOpen = t.menuCloseOpen.bind(v(t)), t.handleSubmenu = t.handleSubmenu.bind(v(t)), t;
    }

    var t, o, i;
    return function (e, n) {
      if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), n && g(e, n);
    }(n, r.a.Component), t = n, (o = [{
      key: "render",
      value: function value() {
        var e = this.props,
            n = e.menu,
            t = e.header,
            o = e.footer,
            i = e.config,
            s = e.Link,
            c = e.location,
            u = this.state.menuOpen,
            m = this.state.currentPage;
        return c && (m = c.pathname), r.a.createElement(a.Provider, {
          value: d({}, this.state, {
            currentPage: m,
            handleSubmenu: this.handleSubmenu,
            Link: s
          })
        }, r.a.createElement(f, {
          config: i || null,
          menu: n,
          header: t,
          footer: o,
          menuCloseOpen: this.menuCloseOpen,
          isOpen: u
        }));
      }
    }]) && h(t.prototype, o), i && h(t, i), n;
  }();
}]);